import cn from "classnames";
import { BUTTON_VARIANT, ButtonProps } from "./Button.types";
import s from "./Button.module.scss";

export const Button = (props: ButtonProps) => {
  const {
    children,
    type = "button",
    variant = BUTTON_VARIANT.PRIMARY,
    size,
    className,
    active = false,
    disabled = false,
    ...otherProps
  } = props;

  return (
    <button
      type={type}
      className={cn(s.btn, s[variant], className, size && s[size], { [s.disabled]: disabled, [s.active]: active })}
      disabled={disabled}
      {...otherProps}
    >
      {children}
    </button>
  );
};
